/**
 * Where confirmations appear.
 *
 * Bottom-right on a desktop, where it does not cover the table row just acted
 * on; top on a phone, where the bottom edge is the thumb's home and a toast
 * there lands under whatever the user is about to tap next.
 *
 * Styled from the design tokens rather than sonner's defaults, so it sits in
 * the product instead of on top of it, and so dark mode comes for free.
 */
import { Toaster as Sonner } from "sonner";

export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      // Long enough to read a sentence, short enough not to linger over the
      // next action. Errors stay longer because they usually need a decision.
      duration={4000}
      gap={8}
      offset={16}
      mobileOffset={16}
      toastOptions={{
        classNames: {
          toast:
            "!rounded-md !border !border-card-edge !bg-surface !text-ink !shadow-card !font-sans !text-sm !px-3.5 !py-3 !gap-2.5",
          title: "!font-medium",
          description: "!text-ink-muted",
          success:
            "!bg-success-soft !text-success-soft-ink !border-transparent",
          error: "!bg-danger-soft !text-danger-soft-ink !border-transparent",
          closeButton: "!bg-surface !border-line !text-ink-muted",
        },
      }}
    />
  );
}
